import React,{useState, useEffect} from 'react'
import { Fade } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import Button from '@mui/material/Button';
import Axios from 'axios';
import config, { getParameterByName, merchantCode } from "../Configs";


export default function Promotion(props) {
  const baseURL = config.baseURL;
  const [promos,setPromos]= useState([{url:'../images/restaurant-bg.jpg'}]);
  const tableNumber = getParameterByName("tableNumber");

   useEffect(()=>{
    const tablenum = getParameterByName("tableNumber");
    if(tablenum){
    props.history.push('/order?' + window.location.href.split('?')[1]);
    return;
    }
  async function fetchPromoImgs() {
    const promosRes= await Axios.get(`${baseURL}/api/promos/?merchantCode=${merchantCode}`);
     console.log(promosRes);
     if(promosRes.data && promosRes.data.length){
     setPromos(promosRes.data);
     }
  }
  fetchPromoImgs();
  },[]); 


  return (
    <div style={{ overflow: "hidden !important", height: "auto" }}>
      <div className="slide-container" style={{ overflow: "hidden", height: "100vh" }}>
        <Fade >
          {
            promos.map(promo => (
                        <div className="each-fade" >
            <img src={promo.url} style={{ width: "100%",height:"100vh", objectFit: "cover" }} />
            </div>
            ))
          }

        </Fade>
      </div>
      <div style={{position:'absolute',zIndex:9999, bottom:"20px", right:"20px", display: "flex", justifyContent: "end", width: "100%", padding: "10px" }}>
        <Button style={{fontSize:"2em", marginRight:"20px"}} variant="contained" color="error" onClick={() => {
          props.history.push(`/entertainment?` + window.location.href.split('?')[1]);
        }}>
          Play Games
        </Button>
        {tableNumber?<Button style={{fontSize:"2em"}} variant="contained" color="warning" onClick={() => {
          props.history.push(`/addmore?` + window.location.href.split('?')[1]);
        }}>
          Back To My Order
        </Button>:<Button style={{fontSize:"2em"}} variant="contained" color="success" onClick={() => {
          props.history.push(`/choose?` + window.location.href.split('?')[1]);
        }}>
          Order Food
        </Button>}

      </div>
    </div>
  )
}

